












































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import Paging from 'biz-ts/src/api/Paging';
import deviceModule from "@/store/module/DeviceModule";
import PaginationTable from "@/component/Table/pagination-table.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import DeviceMessageApi from "@/module/device/DeviceMessageApi";
import {DmessagePqForm} from "@/form/DeviceMessageForm";
import DeviceMessage, {deviceMessageTypeZh} from "@/model/DeviceMessage";
import {messageTypeZh} from "@/model/Message";
import {datePickerOptions} from "@/component/DatePicker";

@Component({
  components: {
    PaginationTable,
    RefreshButton,
  },
})
export default class DeviceMessageView extends Vue {

  private dmsgApi = Container.get(DeviceMessageApi)

  @Ref()
  private ptable!: PaginationTable

  private paging = new Paging<DeviceMessage>()
  private pqForm = new DmessagePqForm()

  private dmsgTypeZh = deviceMessageTypeZh
  private msgLevelZh = messageTypeZh

  private pickerOptions = datePickerOptions

  private created() {
    this.pqForm.deviceId = this.device.id
  }

  private get device() {
    return deviceModule.active
  }

  private async getPaging() {
    return this.dmsgApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }
}
